"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FormLayout = function (props) { return ((0, jsx_runtime_1.jsx)("div", { className: "mx-auto w-full max-w-3xl sm:px-2", children: (0, jsx_runtime_1.jsx)("div", { className: "bg-white py-8 px-6 sm:px-10 shadow rounded-lg", children: props.children }) })); };
exports.FormLayout = FormLayout;
